export const ICON_SIZE = {
    width: '50px',
    height: '50px'
};
